import React from "react";

const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 32 32"
      style={{ fill: "#5C6975", marginRight: "1vh" }}
    >
      <path
        id="Icon_material-edit"
        data-name="Icon material-edit"
        d="M4.5,29.831V36.5h6.666L30.825,16.837l-6.666-6.666ZM35.98,11.682a1.77,1.77,0,0,0,0-2.506L31.821,5.016a1.77,1.77,0,0,0-2.506,0L26.061,8.269l6.666,6.666Z"
        transform="translate(-4.5 -4.496)"
      />
    </svg>
  );
};

export default EditIcon;
